import { render } from "./BlogDetail.vue?vue&type=template&id=a8bb3d1c"
import script from "./BlogDetail.vue?vue&type=script&lang=js"
export * from "./BlogDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__